import { Locale, LocaleString } from "models/locale";
import { FunctionComponent, useState } from "react";
import { StyledIcon, StyledLocale, StyledSelector } from "./selector.styles";
import TranslationModal from "./modal";
import { useFormContext } from "react-hook-form";
import { faGlobe } from "components/icon-library";
import { useLocales } from "stores/hooks/locale";

interface TranslationSelectorProps {
  locale: Locale;
  label: string;
  name: string;
  type: "text" | "textarea";
  onChange: (locale: Locale) => void;
}

const TranslationSelector: FunctionComponent<TranslationSelectorProps> = ({
  label,
  locale,
  name,
  type,
  onChange,
}) => {
  const locales = useLocales();
  const { getValues, setValue, trigger } = useFormContext();
  const [modal, toggleModal] = useState(false);

  const openModal = () => {
    toggleModal(true);
  };

  const value = getValues(name);

  const handleSubmit = async (value: LocaleString) => {
    // set value
    setValue(name, value);

    // validate field after changes
    trigger(name);

    // hide modal
    toggleModal(false);
  };

  return (
    <StyledSelector>
      {locales.map((loc) => {
        return (
          <StyledLocale
            key={loc}
            $active={loc === locale}
            onClick={() => onChange(loc)}
          >
            {loc}
          </StyledLocale>
        );
      })}
      {
        <StyledLocale $active={false}>
          <StyledIcon icon={faGlobe} onClick={openModal} />
        </StyledLocale>
      }
      {modal && (
        <TranslationModal
          onSubmit={handleSubmit}
          onClose={async () => toggleModal(false)}
          type={type}
          value={value}
          label={label}
        />
      )}
    </StyledSelector>
  );
};

export default TranslationSelector;
